export const SortOptions = {
	recommendations: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'created_at',
			direction: 'asc',
			label_en: 'Oldest'
		},
		{
			value: 'name',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
	experiences: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'title',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
	bookings: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'display_id',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
	resources: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'title',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
	resale_marketplace: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'reseller_commission',
			direction: 'desc',
			label_en: 'Commission'
		}
	],
	resale_collection: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'reseller_commission',
			direction: 'desc',
			label_en: 'Commission'
		}
	],
	providers: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'first_name',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
	groups: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'title',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
	providercustomers: [
		{
            value: 'created_at',
            direction: 'desc',
            label_en: 'Newest'
        },
        {
            value: 'name',
            direction: 'asc',
            label_en: 'A-Z'
        }
	],
	providerreviews: [
		{
            value: 'created_at',
            direction: 'desc',
            label_en: 'Newest'
        },
        {
            value: 'rating',
            direction: 'desc',
            label_en: 'Rating'
        }
	],
	pointOfInterests: [
		{
            value: 'created_at',
            direction: 'desc',
            label_en: 'Newest'
        },
        {
            value: 'name',
            direction: 'desc',
            label_en: 'Name'
        }
	],
	//////// ADMIN
	admin_experiences: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'title',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
	adminbookings: [
		{
			value: 'created_at',
			direction: 'desc',
			label_en: 'Newest'
		},
		{
			value: 'display_id',
			direction: 'asc',
			label_en: 'A-Z'
		}
	],
};
